import { ThunkAction } from 'redux-thunk';

import { GetInstrumentsOptions, InventoryResponseData } from 'types/drupal/InstrumentNode';
import { IRootState } from '../root_reducer';

import { InstrumentsApi } from 'providers/api';

import { getManufacturerModelFilters } from 'redux/modules/inventory_filter_data';

const SEARCH = 'grugn-guitars-modern/inventory/SEARCH';
const SEARCH_SUCCESS = 'grugn-guitars-modern/inventory/SEARCH_SUCCESS';
const SEARCH_FAIL = 'grugn-guitars-modern/inventory/SEARCH_FAIL';

const SET_INVENTORY = 'grugn-guitars-modern/inventory/SET_INVENTORY';
const SET_GET_OPTIONS = 'grugn-guitars-modern/inventory/SET_GET_OPTIONS';

export interface InventoryAction {
    type: string;
    response_data?: InventoryResponseData;
    get_options?: Partial<GetInstrumentsOptions>;
}

export interface InventoryState {
    response_data: InventoryResponseData;
    get_options: Partial<GetInstrumentsOptions>;
    isSearching: boolean;
}

const initialState: InventoryState = {
    get_options: { },
    isSearching: false,
    response_data: null
};

export default function (state: InventoryState = initialState, action: InventoryAction): InventoryState {
    switch (action.type) {

        case SEARCH :
            return { ...state, isSearching: true, response_data: null };
        case SEARCH_SUCCESS :
            return { ...state, isSearching: false };
        case SEARCH_FAIL :
            return { ...state, isSearching: false };

        case SET_INVENTORY:
            const { response_data } = action;
            return { ...state, response_data, isSearching: false };
        case SET_GET_OPTIONS:
            const { get_options } = action;
            return { ...state, isSearching: true, get_options: get_options ? get_options : {} };
        default:
            return state;
    }
}
export const sendDataRequest = (get_options?: Partial<GetInstrumentsOptions>): ThunkAction<void, IRootState, null, any> => (dispatch, getState) => {
    dispatch({ type: SET_GET_OPTIONS, get_options });
    dispatch(getManufacturerModelFilters(get_options));
    InstrumentsApi.getInstruments(get_options).then((response_data: InventoryResponseData) => {
        dispatch({ type: SET_INVENTORY, response_data });
    });

};

/**
 * search inventory by string
 */
export const searchInventory = (search: any) => (dispatch: any) => {
    dispatch({
        type: SEARCH
    });
};



// WEBPACK FOOTER //
// ./src/redux/modules/inventory.ts